import React, { Component } from 'react';
import { countMissingLevelStatSettings } from './levelStatIntegrity';
import AdminFilteredContentList from './Admin_FilteredContentList';

class LevelList extends Component {
    render() {
        const {
            Level: levels,
            filter,
            regions,
            stats,
            selectedLevelId,
            onSelectLevel,
            onNewLevel,
        } = this.props;

        return (
            <nav className='admin_list' aria-label="Levels">
                <button type="button" onClick={onNewLevel}>Create New Level</button>

                <AdminFilteredContentList
                    context={{ regions }}
                    filter={filter}
                    getKey={(level, index) => level.id || level.Id || index}
                    kind="level"
                    records={levels}
                    renderRecord={(level) => {
                        const missingCount = countMissingLevelStatSettings(level, stats);
                        const levelId = level.id ?? level.Id;
                        const levelNumber = level.levelNumber ?? level.LevelNumber;
                        const isSelected = levelId === selectedLevelId;
                        const warningText = `${missingCount} broken stat ${missingCount === 1 ? 'reference' : 'references'}`;

                        return (
                        <button
                            className={`listElement admin-level-list__entry${isSelected ? ' is-selected' : ''}`}
                            type="button"
                            aria-current={isSelected ? 'page' : undefined}
                            aria-label={`Edit Level ${levelNumber}${missingCount ? `, ${warningText}` : ''}`}
                            onClick={() => onSelectLevel(level)}
                        >
                            <span>Level {levelNumber}</span>
                            {missingCount > 0 && (
                                <span className="admin-level-list__warning-count">
                                    {missingCount} broken
                                </span>
                            )}
                        </button>
                        );
                    }}
                />
            </nav>
        );
    }
}

export default LevelList;
